"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractArrayOperation = void 0;
const tslib_1 = require("tslib");
const lodash_clonedeep_1 = tslib_1.__importDefault(require("lodash.clonedeep"));
const SchemaPartialSelectorResolver_1 = require("../../Schema/SchemaPartialSelectorResolver");
const DefinitionSelectorsReferenceMapper_1 = require("../../../Schema/Mapper/DefinitionSelectorsReferenceMapper");
const Events_1 = require("../../Event/Events");
const PartialSelectorProcessor_1 = require("../../../Schema/Processor/PartialSelectorProcessor");
const Property_1 = require("../../../Schema/Property/Property");
const PropertyGroup_1 = require("../../../Schema/Property/PropertyGroup");
const ValidatorFactory_1 = require("../../Validator/ValidatorFactory");
class AbstractArrayOperation {
    constructor() {
        this.defSelectorsReferenceMapper = new DefinitionSelectorsReferenceMapper_1.DefinitionSelectorsReferenceMapper();
        this.validatorFactory = new ValidatorFactory_1.ValidatorFactory();
    }
    isArray(selector, form) {
        return !(!form.selectors.has(selector) || !form.selectors.get(selector).isArray);
    }
    addSelectorReferences(selector, form) {
        const formSelector = form.selectors.get(selector);
        const prop = formSelector.property();
        form.qualifications[selector] = true;
        form.qualificationsErrors[selector] = null;
        form.validations[selector] = true;
        form.validationsErrors[selector] = null;
        this.processPartialSelectors(prop);
        if (formSelector.isAnswerable || formSelector.type === Property_1.Property.TYPE_NULL) {
            if (prop.def.validations) {
                this.registerValidatorsEvents(Events_1.Events.DataValidation, prop, prop.def.validations, form);
            }
            if (prop.def.qualifications) {
                this.registerValidatorsEvents(Events_1.Events.DataQualification, prop, prop.def.qualifications, form);
            }
        }
        if (formSelector.belongToSection) {
            form.nodes.sections.updateSectionSelectors(formSelector.sectionUID);
        }
        if (formSelector.belongToGroup) {
            form.nodes.groups.updateGroupSelectors(formSelector.groupUID);
        }
        if (formSelector.belongToArray) {
            form.nodes.arrays.updateArraySelectors(formSelector.arrayUID);
        }
        if (formSelector.isGroup) {
            form.schema.nodes.groups.set(selector, new PropertyGroup_1.PropertyGroup(prop));
        }
    }
    processPartialSelectors(property) {
        const newDef = PartialSelectorProcessor_1.PartialSelectorProcessor.process((0, lodash_clonedeep_1.default)(property.def), property.parentUID, SchemaPartialSelectorResolver_1.defaultPartialSelectorIgnoredKeys);
        property.def = Object.assign(Object.assign({}, property.def), newDef);
        if (property.hasChildProps()) {
            for (const child of property.childProps().values()) {
                this.processPartialSelectors(child);
            }
        }
    }
    registerValidatorsEvents(eventType, prop, validators, form) {
        const targets = [prop.UID, ...this.defSelectorsReferenceMapper.map(prop.def)];
        form.events.selectorEventsManager.addSelectorsTargetedByEvents(targets);
        for (const [validatorName, validatorOpts] of Object.entries(validators)) {
            const validator = this.validatorFactory.create(validatorName, validatorOpts, eventType);
            form.events.addEventTo(prop.UID, eventType, ({ form, data }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                return yield validator.validate({ form, data, prop });
            }));
        }
    }
}
exports.AbstractArrayOperation = AbstractArrayOperation;
